const DEFAULT_API_BASE = 'http://127.0.0.1:8787';

const resolveApiBase = () => {
  const envUrl = import.meta.env.VITE_CLOUDFLARE_API_URL;
  if (envUrl && typeof envUrl === 'string' && envUrl.trim()) {
    return envUrl.trim().replace(/\/$/, '');
  }
  return DEFAULT_API_BASE;
};

const parseJsonSafe = async (response) => {
  const text = await response.text();
  if (!text) return null;
  try {
    return JSON.parse(text);
  } catch {
    return null;
  }
};

const request = async (path, init = {}, accessToken = null) => {
  const headers = {
    ...(init.headers || {}),
  };
  if (accessToken) headers.Authorization = `Bearer ${accessToken}`;
  if (!headers['Content-Type'] && init.body) headers['Content-Type'] = 'application/json';

  const response = await fetch(`${resolveApiBase()}${path}`, {
    ...init,
    headers,
  });
  const data = await parseJsonSafe(response);
  if (!response.ok) {
    throw new Error(data?.error || data?.message || `HTTP ${response.status}`);
  }
  return data;
};

export class QuizApiClient {
  createQuiz(payload, token) {
    return request('/quizzes', { method: 'POST', body: JSON.stringify(payload) }, token);
  }

  importQuizFromGoogleSheet(payload, token) {
    return request(
      '/quizzes/import/google-sheet',
      { method: 'POST', body: JSON.stringify(payload) },
      token
    );
  }

  listMyQuizzes(token) {
    return request('/quizzes/mine', { method: 'GET' }, token);
  }

  getQuizById(quizId, token) {
    return request(`/quizzes/${quizId}`, { method: 'GET' }, token);
  }

  updateQuiz(quizId, payload, token) {
    return request(
      `/quizzes/${quizId}`,
      { method: 'PATCH', body: JSON.stringify(payload) },
      token
    );
  }

  getPublicQuizByCode(code) {
    return request(`/play/${encodeURIComponent(code)}`, { method: 'GET' });
  }

  submitPublicQuizByCode(code, payload, token = null) {
    return request(
      `/play/${encodeURIComponent(code)}/submit`,
      { method: 'POST', body: JSON.stringify(payload) },
      token
    );
  }

  getMyQuizResults(token) {
    return request('/users/me/quiz-results', { method: 'GET' }, token);
  }

  getGuestQuizResults(guestId) {
    const qs = new URLSearchParams({ player_id: String(guestId || '') });
    return request(`/public/quiz-results?${qs.toString()}`, { method: 'GET' });
  }

  listPublicQuizzes({ subject = 'ielts', limit = 6 } = {}) {
    const qs = new URLSearchParams();
    if (subject) qs.set('subject', subject);
    if (limit != null) qs.set('limit', String(limit));
    return request(`/public/quizzes?${qs.toString()}`, { method: 'GET' });
  }
}

